import styled from '@emotion/styled'

export const Warning = styled.div`
  background: #FEECE8;
  border-radius: 0.5rem;
  color: #1C212E;
  font-family: Roboto;
  font-size: 0.875rem;
  padding: 1rem;
`
